import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link } from "gatsby"
import React from "react"
import logo2 from "../images/logo2.png"
import { useLanguage } from "../contexts/LanguageContext"

function Footer() {
  const { t } = useLanguage()

  const usefulLinks = [
    { text: t("footerHome"), path: "/" },
    { text: t("footerWhoAreWe"), path: "/about/" },
    { text: t("footerCompanyStructure"), path: "/about/structure" },
    { text: t("footerOurServices"), path: "/certification/services" },
    {
      text: t("footerCertificationBenefits"),
      path: "/certification/benefits",
    },
    {
      text: t("footerMeaningHalal"),
      path: "/about/halal-meaning",
    },
  ]

  const contactLinks = [
    { text: t("footerApply"), path: "/contact/apply" },
    {
      text: t("footerRequestInformation"),
      path: "/contact/information",
    },
    { text: t("footerFeedback"), path: "/contact/feedback" },
    { text: t("footerComplaint"), path: "/contact/complaint" },
    {
      text: t("footerCertificateCheck"),
      path: "/contact/check",
    },
    {
      text: t("footerLocations"),
      path: "/about/locations",
    },
  ]

  return (
    <footer className="w-full bg-white border-t border-slate-200">
      <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 py-10 scr800:py-12">

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 scr800:gap-16">

          <div className="flex items-start">
            <img
              src={logo2}
              alt={t("footerLogoAlt")}
              className="h-40 scr800:h-48 w-auto"
            />
          </div>

          <div>
            <h3 className="font-poppins font-semibold text-xs text-slate-900 uppercase tracking-wide mb-4">
              {t("footerUsefulLinks")}
            </h3>

            <ul className="font-open text-sm text-slate-600 flex flex-col gap-2.5">
              {usefulLinks.map((link) => (
                <li key={link.text}>
                  <Link
                    to={link.path}
                    className="hover:text-teal-600 transition-colors duration-300"
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-6">
              <div className="flex items-center gap-3">

                <a
                  href="https://twitter.com/CorrectHalal"
                  aria-label="Twitter"
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 rounded-full flex items-center justify-center bg-teal-500 hover:bg-teal-600 transition-all duration-300"
                >
                  <FontAwesomeIcon
                    icon={faTwitter}
                    className="text-white"
                    size="sm"
                  />
                </a>

                <a
                  href="https://www.facebook.com/HalalCorrect/"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 rounded-full flex items-center justify-center bg-teal-500 hover:bg-teal-600 transition-all duration-300"
                >
                  <FontAwesomeIcon
                    icon={faFacebookF}
                    className="text-white"
                    size="sm"
                  />
                </a>

                <a
                  href="https://www.instagram.com/halalcorrectcertification/"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 rounded-full flex items-center justify-center bg-teal-500 hover:bg-teal-600 transition-all duration-300"
                >
                  <FontAwesomeIcon
                    icon={faInstagram}
                    className="text-white"
                    size="sm"
                  />
                </a>

                <a
                  href="https://www.linkedin.com/company/tqhcc-halalcorrectcertification/"
                  aria-label="LinkedIn"
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 rounded-full flex items-center justify-center bg-teal-500 hover:bg-teal-600 transition-all duration-300"
                >
                  <FontAwesomeIcon
                    icon={faLinkedinIn}
                    className="text-white"
                    size="sm"
                  />
                </a>

              </div>
            </div>
          </div>

          <div>
            <h3 className="font-poppins font-semibold text-xs text-slate-900 uppercase tracking-wide mb-4">
              {t("footerContactUs")}
            </h3>

            <ul className="font-open text-sm text-slate-600 flex flex-col gap-2.5">
              {contactLinks.map((link) => (
                <li key={link.text}>
                  <Link
                    to={link.path}
                    className="hover:text-teal-600 transition-colors duration-300"
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-6 pt-5 border-t border-slate-200">
              <h3 className="font-poppins font-semibold text-xs text-slate-900 uppercase tracking-wide mb-2">
                {t("footerScope")}
              </h3>

              <p className="font-open text-sm text-slate-500 leading-relaxed">
                {t("footerScopeDescription")}
              </p>
            </div>
          </div>

        </div>

        <div className="border-t border-slate-200 mt-10 pt-4">
          <p className="font-poppins font-light text-xs scr800:text-sm text-slate-500 text-center">
            © {t("footerCopyright")}{" "}
            <span className="font-semibold text-teal-600">
              Halal Correct Certification.
            </span>{" "}
            {t("footerAllRightsReserved")} — Powered by CODAWIZ COMPANY
          </p>
        </div>

      </div>
    </footer>
  )
}

export default Footer